module.exports = __webpack_public_path__ + "img/img1.c1b4d95b.svg";